// extracted by mini-css-extract-plugin
export default {"osImage":"Server_osImage__SbKvt","renewalCh":"Server_renewalCh__BDsep","active":"Server_active__8u-aB"};